import React from 'react';
import Loader from 'react-loader-spinner'
import { checkTextTranslation } from '../utils/useful'

export default class LoaderButton extends React.Component {

    state = {
        isLoading: false,
        opacity: 1
    }

    onClick = () => {
        if (!this.props.isLoading) {
            this.props.onClick()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isLoading !== prevProps.isLoading) {
            this.setState({ opacity: 0 })
            setTimeout(() => {
                this.setState({ isLoading: this.props.isLoading })
                this.setState({ opacity: 1 })
            }, 300);
        }
    }

    render() {
        return (
            <div className='position-relative '>
                <button className={(this.props.className ?? ' py-1 ')} onClick={() => { if (!this.props.disabled && !this.state.isLoading) { this.onClick() } }} style={{ filter: this.props.disabled ? 'saturate(20%) ' : '', background: this.props.background, backgroundImage: (this.props.backgroundImage ?? this.props.background), boxShadow: this.props.shadow, color: '#fff', transition: 'all 0.5s' }} >

                    <div className={' w-100 ' + (this.props.icon ? "flexcb" : "flexcc")} style={{}}>
                        <div className='position-relative'>
                            <div className='position-relative mx-3'>
                                <p className='text-small text-semibold' style={{ color: this.props.color ?? null, opacity: !this.state.isLoading ? 1 : 0, whiteSpace: 'nowrap' }}>{checkTextTranslation(this.props.text)}</p>

                                <div className='loader-container flexcc position-absolute w-100 h-100' style={{ justifyContent: this.props.justifyContent ?? 'center', top: 1, left: 0, opacity: this.state.isLoading ? 1 : 0 }}>
                                    <Loader
                                        type={this.props.type ?? "Grid"}
                                        color={this.props.color ?? "#ffffffdd"}
                                        height={this.props.width ?? 20}
                                        width={this.props.height ?? 20}
                                    />
                                </div>
                            </div>
                        </div>

                        {this.props.icon && (
                            <div className={'d-flex p-2 mrd-2 ' + (this.props.iconClass ?? 'default-btn-icon')} >
                                <img className='rtl-button' src={this.props.icon} height={18} />
                            </div>
                        )}
                        {this.props.icon2 && (
                            <div className={'d-flex p-2 mrd-2 ' + (this.props.iconClass ?? 'default-btn-icon2' )} >
                                <img className='rtl-button' src={this.props.icon2} height={18} />
                            </div>
                        )}
                    </div>

                </button>

            </div>

        )
    }
}